import React from "react";
import { Form, Input, Row, Col, Select } from "antd";
import { US_STATE_CODES } from "../constants/usStates";
import {
  PROJECT_COUNTRY_OPTIONS,
  getAddressFieldConfig,
} from "../constants/countryAddress";

/**
 * Project site address (job site). Country / Region matches the legacy modal Select;
 * other controls use default bordered Input/Select like the rest of project forms.
 * All fields are optional.
 */
export default function ProjectAddressFormFields({ form }) {
  const countryCode = Form.useWatch("country_code", form);
  const {
    regionLabel,
    postalLabel,
    regionPlaceholder,
    postalPlaceholder,
    useUsStateDropdown,
  } = getAddressFieldConfig(countryCode);

  const handleCountryChange = () => {
    form.setFieldsValue({ state: undefined });
  };

  return (
    <>
      <div className="font-medium mb-1 mt-1">Project site address</div>
      <p className="text-xs text-gray-500 mb-3">
        Physical location of the project (not your company mailing address).
      </p>

      <Form.Item label="Street Address" name="street_address">
        <Input />
      </Form.Item>

      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <Form.Item
            label="Country / Region"
            name="country_code"
            initialValue="usa"
          >
            <Select style={{ width: "100%" }} onChange={handleCountryChange}>
              {PROJECT_COUNTRY_OPTIONS.map(({ value, label }) => (
                <Select.Option key={value} value={value}>
                  {label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item label="City" name="city">
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <Form.Item label={regionLabel} name="state">
            {useUsStateDropdown ? (
              <Select
                style={{ width: "100%" }}
                allowClear
                showSearch
                optionFilterProp="children"
                placeholder={regionPlaceholder}
              >
                {US_STATE_CODES.map((code) => (
                  <Select.Option key={code} value={code}>
                    {code}
                  </Select.Option>
                ))}
              </Select>
            ) : (
              <Input placeholder={regionPlaceholder} />
            )}
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item label={postalLabel} name="postal_code">
            <Input placeholder={postalPlaceholder} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}
